import { graphql, useStaticQuery } from "gatsby";
import React, { useCallback } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import Modal from "./modal";

const ProductNotesModal = ({ show, onHide, data }) => {
  const { labelManagerLabels } = useStaticQuery(graphql`
    {
      labelManagerLabels: labelManagerLabels {
        close
      }
    }
  `);

  const ref = useRef(null);

  useEffect(() => {
    if (show && ref.current) {
      ref.current.focus();
    }
  }, [show]);

  const closeDialog = useCallback(() => {
    if (ref.current) {
      onHide();
    }
  }, [onHide]);

  const onKeyDown = useCallback(
    (e) => {
      if (e.key === "Escape") {
        closeDialog();
      }
    },
    [closeDialog]
  );

  return (
    <Modal>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
      <div
        ref={ref}
        className={`error-modal${show ? " error-modal--show" : ""} product-notes-modal`}
        role="dialog"
        aria-hidden={!show}
        onKeyDown={onKeyDown}
      >
        <div className="error-modal__dialog" role="document">
          <div className="error-modal__alert ">
            <div className="error-modal__alert-content error-modal__alert-content-error error-modal__alert-content-product-notes">
              {data.titlePopUp && (
                <div className="error-modal__alert-title error-modal__alert-title-error">
                  {data.titlePopUp}
                </div>
              )}
              {data.textPopUp && (
                <div
                  className="error-modal__alert-description"
                  dangerouslySetInnerHTML={{ __html: data.textPopUp }}
                ></div>
              )}
              <div className="error-modal__alert-cta">
                <button
                  className="error-modal__alert-close button primary blue"
                  onClick={closeDialog}
                >
                  {labelManagerLabels.close}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ProductNotesModal;
